import { observer } from "mobx-react-lite";
import { useForm } from "react-hook-form";

import { useFunctionDialogContext } from "@/components/FunctionsModal";
import { useFunctionForm } from "@/components/FunctionsModal/hooks/useFunctionForm";
import { FunctionFormValues } from "@/components/FunctionsModal/Types";
import { usePlayground } from "@/components/Playground/playground-store";
import SchemaEditor from "@/components/SchemaEditor";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { JSONSchema } from "@/types";

const defaultFormValues: JSONSchema = {
  type: "object",
  properties: {},
  required: [],
  additionalProperties: false,
};

export const FunctionForm = observer(() => {
  const { editingFunction: initialValues, aiAssistantPortalContainer } = useFunctionDialogContext();
  const initialJson = initialValues ?? defaultFormValues;
  const form = useForm<FunctionFormValues>({
    defaultValues: {
      ...initialJson,
      json: initialJson,
    },
  });

  const { handleSubmit, closeForm } = useFunctionForm();

  const playground = usePlayground();
  const initialJSON = initialValues ?? defaultFormValues;

  return (
    <Form {...form}>
      <div className="flex flex-col gap-4">
        <div className="space-y-8">
          <SchemaEditor
            isFunction
            format={playground.template_format}
            onSubmit={value => {
              handleSubmit(value as unknown as FunctionFormValues);
            }}
            schema={initialJSON}
            aiAssistantPortalContainer={aiAssistantPortalContainer}
          >
            <Button variant="outline" size="lg" onClick={closeForm}>
              Cancel
            </Button>
          </SchemaEditor>
        </div>
      </div>
    </Form>
  );
});
